<template >
    <div>
        <div class="menu__body">
            <div class="manager">
                <div class="manager-item">
                    <span>推荐管理</span>
                    <span class="switch" :class="{'on': privacyChecked}" @click="onRecommendChange"></span>
                </div>
                <div class="item-tip">
                    <span>开启开关后，平台将收集个人行为等信息，用于个性化推荐，为您提供更好的服务</span>
                </div>
            </div>
            <ul class="nav">
                <li class="nav__item" v-for="(item, index) in info" :key="index">
                  <a :href="item.url" class="nav__item-link">  
                    <span class="nav__item-text">{{item.title}}</span>  
                    <span class="badge"></span> 
                  </a>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
export default {   
    data() {
        return {
            privacyChecked: this.checkPrivacyStorage(),
            info: [
                {
                    title:'隐私政策',
                    url: 'https://ilisten.idaddy.cn/home/privacy'
                },
                {
                    title: '用户服务协议',
                    url: 'https://www.idaddy.cn/mobile/vip/xieyi.html'
                }             
            ]
        }
    },
    mounted() {

    },
    methods: {
        checkPrivacyStorage() {
            let privacyStorage = localStorage.getItem('privacy_recommend')
            let result = false
            if (!privacyStorage) {
                localStorage.setItem('privacy_recommend', '1')
                result = true
            } else if (privacyStorage === '1') {
                result = true
            }
            return result
        },
        onRecommendChange(e) {
            let val = this.privacyChecked
            if (!val) {
                localStorage.setItem('privacy_recommend', '1')
            } else {
                localStorage.setItem('privacy_recommend', '0')
            }
            this.privacyChecked = !val
        }
    }
}
</script>

<style lang="less" scoped>
@import "~@/styles/fn";

.menu__body{
    width: 100%;
    min-height: 100vh;
    background-color: #f4f4f8;
}      
.menu--small{   
    width: 110px;   
}
.manager {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px 24px;
  background-color: #fff;
  &-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f4f4f8;
    height: 60px;
    font-size: 16px;
    color: #6c6c74;
  }
  .item-tip {
    padding: 10px 0;
    font-size: 13px;
    line-height: 19px;
    color: #a0a0a6;
  }
  .switch {
    width: 54px;
    height: 34px;
    .bg("~@/assets/privacyAgreement/switch-off.png");
    &.on {
        .bg("~@/assets/privacyAgreement/switch-on.png");
    }
  }
}
.nav{   
    list-style: none;   
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    margin-top: 12px;
    background-color: #fff;
}   
           
.nav__item   
{   
    display: block;
    position: relative;
    width: 100%;
    height: 60px;
    padding: 0 24px;
    box-sizing: border-box;
}   
           
.nav__item-link   
{   
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    text-decoration: none;   
    color: #6c6c74;
    border-bottom: 1px solid #f4f4f8;   
}   
.nav__item:last-child .nav__item-link   
{   
   border-bottom: none;   
}   
.badge   
{   
    display: block;
    .bg("~@/assets/privacyAgreement/left.png");
    width: 5px;
    height: 10px;  
}           
</style>